import React from 'react';
import { useTranslation } from 'react-i18next';
import { Marquee } from '../components/Marquee';

export const Home: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-1 text-primary">{t('common.appName')}</h1>
      <p className="text-text-secondary text-lg mb-6">{t('common.festivalName')}</p>
      <Marquee />
    </div>
  );
};
